import * as React from 'react';

const LoginPageLogo = () => (
  <img src={'/assets/HAIDI_medium_cropped.png'} alt={'HAIDI logo'} />
);

LoginPageLogo.displayName = 'LoginPageLogo';

LoginPageLogo.propTypes = {};

export default LoginPageLogo;
